import r, { useState as c } from "react";
import n from "./index249.mjs";
import l from "classnames";
const i = 300, u = ({ text: e }) => {
  const [s, o] = c(!0);
  return typeof e != "string" ? null : /* @__PURE__ */ r.createElement("div", { className: n.container }, /* @__PURE__ */ r.createElement(
    "div",
    {
      "data-testid": "description",
      className: l(n.description, {
        [n.truncated]: (e == null ? void 0 : e.length) > i && s
      }),
      id: n["room-description"],
      dangerouslySetInnerHTML: { __html: e }
    }
  ), (e == null ? void 0 : e.length) > i ? /* @__PURE__ */ r.createElement(
    "span",
    {
      className: n["view-more-less"],
      onClick: () => o((a) => !a)
    },
    I18n.t(
      `booking_engine.information.${s ? "view_more" : "view_less"}`
    )
  ) : null);
};
export {
  u as Description,
  i as MAX_LENGTH
};
